export default "__VITE_ASSET__ee7cb1d6__"